/**
 * Query params จาก URL เกม
 * ตัวอย่าง: /?user_id=12345&brand=sga&source=lobby&redirect=https://...
 */
const EMPTY = Object.freeze({
  userId: '',
  brand: '',
  source: '',
  redirect: '',
});

export function getUrlParams() {
  if (typeof window === 'undefined') return { ...EMPTY };
  try {
    const sp = new URLSearchParams(window.location.search);
    return {
      userId: (sp.get('user_id') || sp.get('userId') || '').trim(),
      brand: (sp.get('brand') || sp.get('brand_id') || sp.get('brandId') || '').trim(),
      source: (sp.get('source') || '').trim(),
      redirect: (sp.get('redirect') || '').trim(),
    };
  } catch {
    return { ...EMPTY };
  }
}

export function appendUrlParams(baseUrl, params = {}) {
  if (!baseUrl) return baseUrl;
  try {
    const url = new URL(baseUrl, window.location.origin);
    if (params.userId) url.searchParams.set('user_id', params.userId);
    if (params.brand) url.searchParams.set('brand', params.brand);
    if (params.source) url.searchParams.set('source', params.source);
    return url.toString();
  } catch {
    return baseUrl;
  }
}
